import { render, staticRenderFns } from "./dui-icon-video.vue?vue&type=template&id=1d74ee25&scoped=true&"
var script = {}
import style0 from "./dui-icon-video.vue?vue&type=style&index=0&id=1d74ee25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d74ee25",
  null
  
)

export default component.exports